import { GetSharePointAuthToken } from './GetSharePointAuthToken';
import { GetUserAttachmentPolicyCheckerDelegate } from './GetUserAttachmentPolicyCheckerDelegate';
import { LoadAttachmentInformationDelegate } from './LoadAttachmentInformationDelegate';
import { ClickAttachmentFileDelegate } from './ClickAttachmentFileDelegate';
import { GetGroupMailboxInfoDelegate } from './GetGroupMailboxInfoDelegate';
import { InitializeWacAttachmentInfoDelegate } from './InitializeWacAttachmentInfoDelegate';

// Wrapping in a getter is needed for consumers that import the variable before it is set
function getter<TFn extends Function>(fnGetter: () => TFn): TFn {
    return <any>function(...args: any[]) {
        return fnGetter()(...args);
    };
}

let getSharePointAuthTokenImpl: GetSharePointAuthToken;
let getUserAttachmentPolicyCheckerImpl: GetUserAttachmentPolicyCheckerDelegate;
let loadAttachmentInformationImpl: LoadAttachmentInformationDelegate;
let clickAttachmentFileImpl: ClickAttachmentFileDelegate;
let getGroupMailboxInfoImpl: GetGroupMailboxInfoDelegate;
let initializeWacAttachmentInfoImpl: InitializeWacAttachmentInfoDelegate;

export function initializeGroupFilesHubCallbacks(
    getSharePointAuthTokenFunc: GetSharePointAuthToken,
    getUserAttachmentPolicyCheckerFunc: GetUserAttachmentPolicyCheckerDelegate,
    loadAttachmentInformationFunc: LoadAttachmentInformationDelegate,
    clickAttachmentFileFunc: ClickAttachmentFileDelegate,
    getGroupMailboxInfoFunc: GetGroupMailboxInfoDelegate,
    initializeWacAttachmentInfoFunc: InitializeWacAttachmentInfoDelegate
): void {
    getSharePointAuthTokenImpl = getSharePointAuthTokenFunc;
    getUserAttachmentPolicyCheckerImpl = getUserAttachmentPolicyCheckerFunc;
    loadAttachmentInformationImpl = loadAttachmentInformationFunc;
    clickAttachmentFileImpl = clickAttachmentFileFunc;
    getGroupMailboxInfoImpl = getGroupMailboxInfoFunc;
    initializeWacAttachmentInfoImpl = initializeWacAttachmentInfoFunc;
}

export const getSharePointAuthToken = getter(() => getSharePointAuthTokenImpl);
export const getUserAttachmentPolicyChecker = getter(() => getUserAttachmentPolicyCheckerImpl);
export const loadAttachmentInformation = getter(() => loadAttachmentInformationImpl);
export const clickAttachmentFile = getter(() => clickAttachmentFileImpl);
export const getGroupMailboxInfo = getter(() => getGroupMailboxInfoImpl);
export const initializeWacAttachmentInfo = getter(() => initializeWacAttachmentInfoImpl);
